/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Tab_BomInputs */

const vi_packaging_tab_bom = /** @type {(inputs: Packaging_Tab_BomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Định mức theo SP`)
};

/**

* @param {Packaging_Tab_BomInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_tab_bom = /** @type {((inputs?: Packaging_Tab_BomInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Tab_BomInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_tab_bom(inputs)
});